/**
 * Shared class-name tokens for the studio's dark-glass panels.
 *
 * Kept in a non-component module so component files stay component-only
 * (react-refresh fast-refresh requirement) — same convention as the event
 * planner's `toolbarStyles.ts`.
 */

export const PANEL =
  'pointer-events-auto rounded-xl border border-white/10 bg-slate-950/90 text-white backdrop-blur-md'

export const FIELD =
  'w-full rounded border border-white/10 bg-black/40 px-2 py-1 text-xs text-white/90 ' +
  'outline-none focus:border-sky-400/50'

export const LABEL = 'text-[10px] font-semibold uppercase tracking-wide text-white/40'

export const SECTION_TITLE = 'text-[10px] font-bold uppercase tracking-widest text-white/30'

export const ICON_BTN =
  'flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-white/50 ' +
  'hover:bg-white/10 hover:text-white disabled:opacity-30'
